import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addProperty = createAsyncThunk('property/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/properties/create-properties`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editProperty = createAsyncThunk('property/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-properties/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteProperty = createAsyncThunk('property/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/properties/delete-properties/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllProperty = createAsyncThunk('property/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-all-properties`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPropertyByID = createAsyncThunk('property/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-properties/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editSchedule = createAsyncThunk('property/schedule/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-properties/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addiCal = createAsyncThunk('property/iCal/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/properties/create-properties`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editiCal = createAsyncThunk('property/iCal/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-properties/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllTasks = createAsyncThunk('property/allTask', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/task/get-all-task`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllConsumables = createAsyncThunk('property/allConsumables', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/consumable/get-all-consumable`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const createManualPropertySchedule = createAsyncThunk('property/schedule/create', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/property-schedule/create-property-schedule`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editManualPropertySchedule = createAsyncThunk('property/schedule/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/property-schedule/update-property-schedule/${data?.scheduleID}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPropertyScheduleById = createAsyncThunk('property/schedule/getById', async (data, { rejectWithValue }) => {
  const params = data.params
  try {
    const response = await axiosInstance.get(`/property-schedule/get-property-schedule-by-property-id/${data?.property_id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const getSchedulePropertyDataById = createAsyncThunk('property/scheduleData/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning/get-cleaning-report-by-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deletePropertySchedule = createAsyncThunk('property/schedule/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/property-schedule/delete-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const extendPropertySchedule = createAsyncThunk('property/schedule/extend', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/property-schedule/extend-cleaning/${data?.scheduleID}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getTooltipIcal = createAsyncThunk('property/get-tooltip', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/ical-tool-tip/get-all-ical-tool-tips`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getCityByCityName = createAsyncThunk('property/get-city-by-city-name', async (city, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/city/get-city-by-city-name?city=${city}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllPropertiesName = createAsyncThunk('property/all/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-all-properties-name`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPropertyScheduleDetailsById = createAsyncThunk('property/schedule-details/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getShareCleanningDetails = createAsyncThunk('property/share-cleanning-details/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning/share-cleaning/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allProperty: [],
  allTasks: [],
  allConsumables: [],
  allScheduledProperties: [],
  scheduledProperties: null,
  scheduledPropertiesDetails: [],
  shareableLink:null,
  getProperty: null,
  allPropertiesName: [],
  property: null,
  iCalData: null,
  error: null
}

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(addProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(editProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteProperty.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllProperty.pending, (state) => {
        state.isLoading = true
        state.allProperty = []
      })
      .addCase(getAllProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.allProperty = action.payload?.data?.data
      })
      .addCase(getAllProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getPropertyByID.pending, (state) => {
        state.isLoading = true
        state.getProperty = null
      })
      .addCase(getPropertyByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getProperty = action.payload?.data?.data
      })
      .addCase(getPropertyByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(createManualPropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createManualPropertySchedule.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(createManualPropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editSchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editSchedule.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(editSchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addiCal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addiCal.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(addiCal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editiCal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editiCal.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(editiCal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllTasks.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllTasks.fulfilled, (state, action) => {
        state.isLoading = false
        state.allTasks = action.payload?.data?.data
      })
      .addCase(getAllTasks.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllConsumables.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllConsumables.fulfilled, (state, action) => {
        state.isLoading = false
        state.allConsumables = action.payload?.data?.data
      })
      .addCase(getAllConsumables.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getPropertyScheduleById.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPropertyScheduleById.fulfilled, (state, action) => {
        state.isLoading = false
        state.allScheduledProperties = action.payload?.data?.data
      })
      .addCase(getPropertyScheduleById.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getSchedulePropertyDataById.pending, (state) => {
        state.isLoading = true
        state.scheduledProperties = []
      })
      .addCase(getSchedulePropertyDataById.fulfilled, (state, action) => {
        state.isLoading = false
        state.scheduledProperties = action.payload?.data?.data
      })
      .addCase(getSchedulePropertyDataById.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deletePropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deletePropertySchedule.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deletePropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(extendPropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(extendPropertySchedule.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(extendPropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getTooltipIcal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getTooltipIcal.fulfilled, (state, action) => {
        state.isLoading = false
        state.iCalData = action?.payload?.data?.data
      })
      .addCase(getTooltipIcal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCityByCityName.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getCityByCityName.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(getCityByCityName.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllPropertiesName.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllPropertiesName.fulfilled, (state, action) => {
        state.isLoading = false
        state.allPropertiesName = action?.payload?.data?.data
      })
      .addCase(getAllPropertiesName.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.allPropertiesName = []
      })
      .addCase(getPropertyScheduleDetailsById.pending, (state) => {
        state.isLoading = true
        state.scheduledPropertiesDetails = []
      })
      .addCase(getPropertyScheduleDetailsById.fulfilled, (state, action) => {
        state.isLoading = false
        state.scheduledPropertiesDetails = action.payload?.data?.data
      })
      .addCase(getPropertyScheduleDetailsById.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getShareCleanningDetails.pending, (state) => {
        state.isLoading = true
        state.shareableLink=null
      })
      .addCase(getShareCleanningDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.shareableLink = action.payload?.data?.data
      })
      .addCase(getShareCleanningDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = propertySlice.actions
export default propertySlice.reducer
